// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 768px) {\n#live-chat-ai-host {\n    visibility: hidden !important;\n    pointer-events: none !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
